import { useRecoilValue } from 'recoil';

import { CarrierLogo } from '@/components/carrier-logo';
import { Text } from '@/components/text';
import { getCarrierName } from '@/lib/models/carrier/utils/get-carrier-name';
import { getCarrierByIdState } from '@/state/carriers';
import { Codeshare } from '@/types';
import { SegmentModeType } from '@/types/api-types';
import { getPreferredIdentifier } from '@/utils/helpers/get-preferred-identifier';
import { tv } from '@/utils/styles';

export interface CodeshareProps {
  codeshare: Codeshare;
  mode: SegmentModeType;
}

const JourneyCodeshare = ({ codeshare, mode }: CodeshareProps) => {
  const { carrierId, isOperator, isPrimary, serviceName } = codeshare;
  const carrier = useRecoilValue(getCarrierByIdState(carrierId));

  if (!carrier) {
    // Carrier was not found, technically this shouldn't happen, but has been hit a few times when testing
    return null;
  }

  const carrierCode = getPreferredIdentifier(carrier.identifiers)?.value;
  const carrierName = getCarrierName(carrier);
  const { base, name } = styles({ isPrimary });

  return (
    <li className={base()}>
      {carrierCode && <CarrierLogo carrierCode={carrierCode} size="4" mode={mode} />}
      <Text className={name()}>
        {carrierName}
        {serviceName ? ` - ${serviceName}` : ''}
        {isOperator ? `*` : ''}
      </Text>
    </li>
  );
};

const styles = tv({
  slots: {
    base: 'flex items-center whitespace-nowrap rounded-md bg-grey-50 px-2 py-1',
    name: 'm-0 ml-2 text-sm text-grey-700',
  },
  variants: {
    isPrimary: {
      true: {
        base: 'bg-grey-100',
        name: 'font-semibold text-text-primary',
      },
    },
  },
});

export { JourneyCodeshare };
